// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__AgreementLink-icon__CPg23{margin-right:var(--tri-space-150);margin-bottom:var(--tri-space-50)}`, "",{"version":3,"sources":["webpack://./src/pages/PostApplicationPages/ApplicationAgreements/AgreementLink/styles.module.scss"],"names":[],"mappings":"AACE,oCACE,iCAAA,CACA,iCAAA","sourcesContent":[".AgreementLink {\n  &-icon {\n    margin-right: var(--tri-space-150);\n    margin-bottom: var(--tri-space-50);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AgreementLink-icon": `sputnik__AgreementLink-icon__CPg23`
};
export default ___CSS_LOADER_EXPORT___;
